<template>
    <div :class="['verify-container ', currentStyle]" :style="cssVars">
        <!-- 正品显示 -->
        <div v-if="value.showIndex === 0" class="certification-card certification-card-check">
            <div class="card-header">
                <div class="icon-shield">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path
                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
                        </path>
                        <path d="m9 12 2 2 4-4"></path>
                    </svg>
                </div>
                <h2 class="title">{{ value.data[0].title }}</h2>
            </div>
            <p v-if="value.data[0].text" class="text">{{ value.data[0].text }}</p>
        </div>

        <!-- 非正品显示 -->
        <div v-if="value.showIndex === 1" class="certification-card certification-card-alert">
            <div class="card-header">
                <div class="lucide-shield">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path
                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
                        </path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <h2 class="title">{{ value.data[1].title }}</h2>
            </div>
            <p v-if="value.data[1].text" class="text">{{ value.data[1].text }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VerifyView',
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        cssVars() {
            return {
                '--title-font-family': this.value.titleFont.fontFamily,
                '--title-font-size': this.value.titleFont.fontSize,
                '--title-font-weight': this.value.titleFont.fontWeight,
                '--title-color': this.value.titleFont.color,
                '--title-line-height': this.value.titleFont.lineHeight,
                '--text-font-family': this.value.textFont.fontFamily,
                '--text-font-size': this.value.textFont.fontSize,
                '--text-font-weight': this.value.textFont.fontWeight,
                '--text-color': this.value.textFont.color,
                '--text-line-height': this.value.textFont.lineHeight,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.verify-container {
    width: 100%;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;

    .certification-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 16px 24px;
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #e1f7eb;
        border-radius: 12px;
        background-color: oklch(97.932% 0.02065 166.41 / 0.5);
        border-color: oklch(95% 0.052 163.051 / 0.5);
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        .icon-shield,
        .lucide-shield {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .title {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            font-family: var(--title-font-family);
            font-size: var(--title-font-size);
            font-weight: var(--title-font-weight);
            color: var(--title-color);
            line-height: var(--title-line-height);
        }
    }

    .text {
        margin-top: 6px;
        font-family: var(--text-font-family);
        font-size: var(--text-font-size);
        font-weight: var(--text-font-weight);
        color: var(--text-color);
        line-height: var(--text-line-height);
    }

    .certification-card-check {
        .icon-shield {
            color: oklch(69.6% 0.17 162.48);
        }

        .title {
            color: oklch(37.8% 0.077 168.94);
        }

        .text {
            color: oklch(59.6% 0.145 163.225);
        }
    }

    .certification-card-alert {
        .lucide-shield {
            color: oklch(62.8% 0.211 25.234);
        }

        .title {
            color: oklch(39.0% 0.122 14.141);
        }

        .text {
            color: oklch(54.9% 0.178 23.356);
        }
    }

    &.style1 {
        // 基础样式
    }
}
</style>